
import Vue, { computed } from 'vue'
import ShipBody from './ShipBody.vue'
// import { SET_SELECTED_HATCH_INDEX, DELETE_VESSEL_HATCH, ADD_VESSEL_HATCH } from '@/core/services/store/vesselProfile.module'
import { mapActions, mapGetters } from 'vuex'
import store from '@/core/services/store'
import { VesselHatchType } from "@/types/vesselProfile"
import configs from "@/config/config"
// import Bow from '@/components/vesselOperationMonitoring/assets/Bow.svg'

const SECTION_WIDTH = 70
const TAIL_WIDTH = 100
const WIDTH_20_FOOT_CONTAINER = 25
const WIDTH_40_FOOT_CONTAINER = 50
const HEIGHT_CONTAINER = 10


interface Section {
  id: string
  type: VesselHatchType
  hasBayFore: boolean
  bayFore: number
  bayAfter: number
  bay40: number
  hasBay40: boolean
  hasBayAfter: boolean
  underDeck: {
    rowCount: number
  }
  onDeck: {
    rowCount: number
  }
}



interface Ship {
  head: Section
  tail: Section
  middle: Section[]
}

export default Vue.extend({
  components: {
    ShipBody: ShipBody
  },
  data: function () {
    return {
      headImage: configs.VUE_APP_BASE_YARDVIEW + "media/svg/vesselProfile/Stern.svg",
      tailImage: configs.VUE_APP_BASE_YARDVIEW + "media/svg/vesselProfile/Bow.svg",
      craneImage: configs.VUE_APP_BASE_YARDVIEW + "media/svg/vesselProfile/Crane.svg",
      bridgeImage: configs.VUE_APP_BASE_YARDVIEW + "media/svg/vesselProfile/Bridge.png",
      funnelImage: configs.VUE_APP_BASE_YARDVIEW + "media/svg/vesselProfile/Funnel.png",

      UnderDeckCellConfig: {},
      SECTION_WIDTH: SECTION_WIDTH,
      TAIL_WIDTH: TAIL_WIDTH,
      selectedHatchIndex: 0,
      isHighlightActive: false,
      VesselHatchType: VesselHatchType,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      sternImage: null,
      bowImage: null,
      bodyImage: null,
      cellImage: null,
      fortyFootImage: null,
      ship: {
        head: {
          id: 'head',
          type: 'head',
          position: 0
        },
        middle: [
          {
            id: '001',
            type: VesselHatchType.Hatch,
            bg: '#ffffff00',
            hasBay40: false,
            hasBayAfter: true,
            hasBayFore: true,
            underDeck: {
              rowCount: 2,
            },
            onDeck: {
              rowCount: 3,
            }
          },
        ]
      },
      showContextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      selectedSection: null as Section | null,
    }
  },
  // created() {
  //   window.addEventListener('contextmenu', (event) => {
  //     event.preventDefault();
  //   });
  // },
  destroyed() {
    window.removeEventListener('contextmenu', (event) => {
      event.preventDefault()
    })
  },
  methods: {
    getSectionGroupConfig() {
      return {

      }


    },
    getSectionConfig(section: Section, index) {
      return {
        x: - SECTION_WIDTH * index + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)),
        y: 150,
        width: SECTION_WIDTH,
        height: 182,

        // image: thi1s.bodyImage,
        sceneFunc: (context, shape) => {
          context.beginPath()
          context.moveTo(0, 0)
          context.lineTo(SECTION_WIDTH, 0)
          context.lineTo(SECTION_WIDTH, 89)
          context.lineTo(0, 89)
          context.closePath()

          // upper part color
          context.fillStyle = ''
          context.fill()

          // bottom part color
          context.beginPath()
          context.moveTo(0, 89)
          context.lineTo(SECTION_WIDTH, 89)
          context.lineTo(SECTION_WIDTH, 182)
          context.lineTo(0, 182)
          context.closePath()

          context.fillStyle = '#1C5B7C'
          context.fill()


        },

      }
    },

    getHatchForeLabelsConfig(section: Section, index) {
      return {
        x: - SECTION_WIDTH * index + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH * 6 / 12 + 6,
        y: 370,
        fill: 'blue',
        listening: false,
        fontStyle: 'normal',
        fontSize: 13,
        text: section.hasBayFore ? String(section.bayFore).padStart(2, '0') : '',
      }
    },
    getHatch40FootLabelsConfig(section: Section, index) {
      return {
        x: - SECTION_WIDTH * index + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH * 4 / 12 + 6,
        y: 350,
        fill: 'red',
        listening: false,
        fontStyle: 'normal',
        fontSize: 13,
        text: section.hasBay40 ? String(section.bay40).padStart(2, '0') : '',
      }
    },

    getHatchAfterLabelsConfig(section: Section, index) {
      return {
        x: - SECTION_WIDTH * index + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH * 2 / 12 + 6,
        y: 370,
        fill: 'blue',
        fontStyle: 'normal',
        listening: false,
        fontSize: 13,
        text: section.hasBayAfter ? String(section.bayAfter).padStart(2, '0') : '',
      }
    },



    getHighlightConfig: function (section, sectionIndex) {
      return {
        // x: - SECTION_WIDTH * sectionIndex + TAIL_WIDTH,
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)),
        y: 0,
        onMouseEnter: function (e: any) {
          const container = e.target.getStage().container()
          container.style.cursor = "crosshair"

        },
        width: SECTION_WIDTH,
        height: 500,
        fill: this.$store.state.vesselProfile.selectedHatchIndex === sectionIndex ? '#ff000022' : '#ffffff00',
        onClick: () => {

          // this.selectedHatchId = sectionIndex
          // this.setSelectedHatchId(section.id)


          this.showContextMenu = false
          this.$store.dispatch({ type: 'setSelectedHatchIndex', index: sectionIndex })


          // this.$emit('selectSection', section.id)


          // Add event listener to reset section.bg on click outside of rectangle
          // document.addEventListener('click', (event) => {
          //   const rect = document.querySelector('#bg' + section.id); // Replace with the appropriate selector for your rectangle
          //   
          //   if (!rect.contains(event.target as Node)) {
          //     section.bg = '#ffffff00';
          //   }
          // });
        },
        onContextMenu: () => {
          //  @contextmenu.stop.prevent="handleRightClick(ship.head, $event)
          this.handleRightClick()
        }
      }
    },

    getOnDeckCellConfig: function (section, index, sectionIndex) {


      const x = (() => -SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH / 2)()
      const y = (() => 145 - index * HEIGHT_CONTAINER + .3)()
      const width = (() => {
        if (section.hasBayFore) return WIDTH_20_FOOT_CONTAINER
        return 0
      })()
      const height = (() => {
        if (section.hasBayFore) return HEIGHT_CONTAINER
        return 0
      })()


      return {
        x,
        y,
        width,
        height,
        fill: 'white',
        listening: false,
        strokeWidth: 0.4,
        stroke: 'black',
      }

    },



    getOnDeckAfterCellConfig(section: Section, index, sectionIndex) {
      return {
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH / 2 - WIDTH_40_FOOT_CONTAINER / 2,
        y: 145 - index * HEIGHT_CONTAINER + .3,
        width: (() => {
          if (section.hasBayAfter) return WIDTH_20_FOOT_CONTAINER
          if (section.hasBay40) return WIDTH_40_FOOT_CONTAINER
          return 0
        })(),
        height: (() => {
          if (section.hasBayAfter || section.hasBay40) return HEIGHT_CONTAINER
          return 0
        })(),
        fill: 'white',
        listening: false,
        strokeWidth: 0.4,

        stroke: '#black',
      }
    },

    getUnderDeckCellConfig(section: Section, index, sectionIndex) {
      return {
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH / 2,
        y: 145 + index * HEIGHT_CONTAINER + .3,
        width: (() => {
          if (section.hasBayFore) return WIDTH_20_FOOT_CONTAINER
          return 0
        })(),
        height: (() => {
          if (section.hasBayFore) return HEIGHT_CONTAINER
          return 0
        })(),
        fill: 'white',
        listening: false,
        strokeWidth: 0.4,
        stroke: '#black',
      }
    },
    getUnderDeckAfterCellConfig(section: Section, index, sectionIndex) {
      return {
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + SECTION_WIDTH / 2 - WIDTH_40_FOOT_CONTAINER / 2,
        y: 145 + index * HEIGHT_CONTAINER + .3,
        width: (() => {
          if (section.hasBayAfter) return WIDTH_20_FOOT_CONTAINER
          if (section.hasBay40) return WIDTH_40_FOOT_CONTAINER
          return 0
        })(),
        height: (() => {
          if (section.hasBayAfter || section.hasBay40) return HEIGHT_CONTAINER
          return 0
        })(),
        fill: 'white',
        listening: false,
        strokeWidth: 0.4,

        stroke: '#black',
      }
    },
    getDeckBridgeConfig(section, sectionIndex) {
      return {
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + 10,
        y: 0,
        width: 65,
        height: 180,
        /*  fill: 'white',
         listening: false,
         stroke: '#black',   */
        image: this.bridgeImage,
      }
    },
    getDeckFunnelConfig(section, sectionIndex) {
      return {
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + 10,
        y: 0,
        width: 55,
        height: 210,
        /*  fill: 'white',
         listening: false,
         stroke: '#black',   */
        image: this.funnelImage,
      }
    },
    getDeckEngineConfig(section, sectionIndex) {
      return {
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + 10,
        y: 0,
        width: 65,
        height: 180,
        /*  fill: 'white',
         listening: false,
         stroke: '#black',   */
        image: this.bridgeImage,
      }
    },
    getDeckCraneConfig(section, sectionIndex) {
      return {
        x: - SECTION_WIDTH * sectionIndex + (TAIL_WIDTH + SECTION_WIDTH * (this.vesselProfileHatches.length - 1)) + 10,
        y: 0,
        width: 180,
        height: 180,
        /*  fill: 'white',
         listening: false,
         stroke: '#black',   */
        image: this.craneImage,
      }
    },
    open(evt) {
      // updates position of context menu 
      this.contextMenuX = evt.pageX || evt.clientX
      this.contextMenuY = evt.pageY || evt.clientY
      // make element focused 
      // @ts-ignore
      Vue.nextTick(() => this.$el.focus())
    },
    handleRightClick(section: Section, event: any) {
      // event.evt.preventDefault();

      this.showContextMenu = !this.showContextMenu
      this.contextMenuX = event.evt.pageX || event.evt.clientX
      this.contextMenuY = event.evt.pageY || event.evt.clientY
      this.selectedSection = section
    },
    /*     addSection(direction: 'left' | 'right', section: Section) {
          const index = this.ship.middle.findIndex((s) => s.id === section.id);
          const newSection: Section = {
            id: `${Date.now()}`, // This should be unique
            type: 'hatch', // Set the default type to 'hatch'
            position: direction === 'left' ? section.position - 110 : section.position + 110,
            hatchType: VesselHatchType.Blank
          };
    
          if (direction === 'left') {
            this.ship.middle.splice(index, 0, newSection);
          } else {
            this.ship.middle.splice(index + 1, 0, newSection);
          }
    
          this.showContextMenu = false;
        }, */
    // deleteSection(section: Section) {
    //   this.showContextMenu = false
    //   this.$store.dispatch({ type: DELETE_VESSEL_HATCH, id: this.selectedHatchData.id })
    // },
    // addSectionToRight(section: Section) {
    //   this.showContextMenu = false
    //   this.$store.dispatch({ type: ADD_VESSEL_HATCH, position: "right" })
    // },
    // addSectionToLeft(section: Section) {
    //   this.showContextMenu = false
    //   this.$store.dispatch({ type: ADD_VESSEL_HATCH, position: "left" })
    // },
  },
  watch: {

  },
  computed: {
    vesselProfile() {

      const vesselProfile = this.$store.state.vesselProfile.vesselProfile
      setTimeout(() => this.$forceUpdate(), 10)
      return vesselProfile
    },
    vesselProfileHatches() {
      return this.vesselProfileHatches
    },
    ...mapGetters({
      selectedHatchData: 'getSelectedHatchData',
      // vesselProfile: 'getVesselProfile',
      vesselProfileHatches: 'getVesselProfileHatches'
    }),

    ...mapActions({
      // setSelectedHatchIndex: SET_SELECTED_HATCH_INDEX,
      // deleteVesselHatch: DELETE_VESSEL_HATCH
    }),
    headConfig() {
      return {
        x: 0,
        y: 150,
        width: TAIL_WIDTH,
        height: 200,
        image: this.sternImage,
      }
    },
    tailConfig() {
      return {
        x: (this.vesselProfileHatches.length ?? 0) * (SECTION_WIDTH) + TAIL_WIDTH,
        y: 120,
        width: TAIL_WIDTH,
        height: 212,
        image: this.bowImage,
      }
    },

    // get position of context menu
    style() {
      return {
        top: this.contextMenuY + 'px',
        left: this.contextMenuX + 'px',
      }
    },
  },

  created() {



  },


  mounted() {
    const sternImage = new window.Image()
    sternImage.src = 'media/svg/vesselProfile/Stern.svg'
    sternImage.onload = () => {
      // set image only when it is loaded
      this.sternImage = sternImage
    }
    const bowImage = new window.Image()
    bowImage.src = 'media/svg/vesselProfile/Bow.svg'
    bowImage.onload = () => {
      this.bowImage = bowImage
    }
    const bodyImage = new window.Image()
    bodyImage.src = 'media/svg/vesselProfile/Body.svg'
    bodyImage.onload = () => {
      this.bodyImage = bodyImage
    }
    const cellImage = new window.Image()
    cellImage.src = 'media/svg/vesselProfile/Cell.svg'
    cellImage.onload = () => {
      this.cellImage = cellImage
    }

    const craneImage = new window.Image()
    craneImage.src = 'media/svg/vesselProfile/Crane.png'
    craneImage.onload = () => {
      this.craneImage = craneImage
    }
    const bridgeImage = new window.Image()
    bridgeImage.src = 'media/svg/vesselProfile/Bridge.png'
    bridgeImage.onload = () => {
      this.bridgeImage = bridgeImage
    }
    const funnelImage = new window.Image()
    funnelImage.src = 'media/svg/vesselProfile/Funnel.png'
    funnelImage.onload = () => {
      this.funnelImage = funnelImage
    }
    const fortyFootImage = new window.Image()
    fortyFootImage.src = 'media/svg/vesselProfile/Cell.svg'
    fortyFootImage.onload = () => {
      this.fortyFootImage = fortyFootImage
    }


  },
})
